const CarouselList = () => import("@/vuepage/content-manage/carouselList");
const AddCarousel = () => import("@/vuepage/content-manage/addCarousel");
const FriendlyLink = () => import("@/vuepage/content-manage/friendlyLink");
const IndustryCase = () => import("@/vuepage/content-manage/industryCase");
const AddIndustry = () => import("@/vuepage/content-manage/addIndustry");
const AddSet = () => import("@/vuepage/content-manage/addSet");
const addProduct = () => import("@/vuepage/content-manage/addProduct");
export default [
  {
    path: "/carousel-list",
    component: CarouselList,
    name: "/carousel-list",
    meta: [{ name: "内容管理" }, { name: "轮播图管理", activeRoute: "/carousel-list" }],
  },
  {
    path: "/add-carousel",
    component: AddCarousel,
    name: "/add-carousel",
    meta: [{ name: "内容管理" }, { name: "新增/编辑轮播图", activeRoute: "/add-carousel" }],
  },
  {
    path: "/industry-case",
    component: IndustryCase,
    name: "/industry-case",
    meta: [
      {
        name: "内容管理",
      },
      {
        name: "行业洞察",
        activeRoute: "/industry-case",
      },
    ],
  },

  {
    path: "/friendly-link",
    component: FriendlyLink,
    name: "/friendly-link",
    meta: [
      {
        name: "内容管理",
      },
      {
        name: "友情链接管理",
        activeRoute: "/friendly-link",
      },
    ],
  },

  {
    path: "/add-industry",
    component: AddIndustry,
    name: "/add-industry",
    meta: [{ name: "内容管理" }, { name: "新增/行业洞察", activeRoute: "/add-industry" }],
  },
  {
    path: "/add-Set",
    component: AddSet,
    name: "/add-Set",
    meta: [{ name: "内容管理" }, { name: "首页推荐", activeRoute: "/add-Set" }],
  },
  {
    path: "/add-Product",
    component: addProduct,
    name: "/add-Product",
    meta: [{ name: "内容管理" }, { name: "产品推荐", activeRoute: "/add-Product" }],
  },
];
